export const BITMOVIN_UI_PLAYER_VERSION = 'v20240821161052'
